import { Box, Button, Container, Modal, Typography } from "@mui/material";
import React from "react";

export default function ConfirmModal(props) {
    const style = {
        backgroundColor: "#EEEEEE",
        top: "50%",
        left: "50%",
        position: "absolute",
        transform: "translate(-50%, -50%)",
        width: "30%",
        boxShadow: 24,
        borderRadius: 5,
        minHeight: "30%",
        minWidth: "30%",
    };

    return (
        <>
            <Modal open={props.open} onClose={props.onClose}>
                <Box
                    sx={style}
                    display="flex"
                    justifyContent="center"
                    flexDirection="column"
                    alignItems="center"
                >
                    <Typography variant="h6">{props.children}</Typography>
                    <Container
                        sx={{
                            py: 4,
                            display: "flex",
                            justifyContent: "space-evenly",
                        }}
                    >
                        <Button
                            color="success"
                            variant="outlined"
                            onClick={props.onConfirm}
                        >
                            Confirm
                        </Button>
                        <Button
                            color="error"
                            variant="outlined"
                            onClick={props.onClose}
                        >
                            Cancel
                        </Button>
                    </Container>
                </Box>
            </Modal>
        </>
    );
}
